export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0);
};

export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatPercentage = (value) => {
  // Convert to number and handle invalid/empty values
  const number = parseFloat(value);
  if (isNaN(number)) return '0%';
  
  // Format with 2 decimal places and add % symbol
  return `${number.toFixed(2)}%`;
};

export const calculateEMI = (principal, interestRate, tenureMonths) => {
  const P = parseFloat(principal);
  const r = (parseFloat(interestRate) / 12) / 100; // Convert annual rate to monthly
  const n = parseFloat(tenureMonths);

  if (!P || !n || isNaN(r) || r < 0) return 0;
  if (r === 0) return Math.round((P / n) * 100) / 100; // Interest-free loan

  // EMI = P * r * (1 + r)^n / ((1 + r)^n - 1)
  const emi = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
  return Math.round(emi * 100) / 100; // Round to 2 decimal places
};

// Add this utility function
export const calculateRemainingPayments = (loan) => {
  if (!loan.tenure_months || !loan.loan_payments) return 0;
  
  const totalPayments = parseInt(loan.tenure_months);
  const madePaments = loan.loan_payments.length;
  
  return Math.max(0, totalPayments - madePaments);
};